/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Button from "react-bootstrap/Button";
import JobStatusModal from "./JobStatusForm";
import Constants from "../../../../common/Constants";
import MasterList from "../../../common/MasterList";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { useTranslation } from "react-i18next";
import {
  fetchMasterList,
  addMasterRecord,
  deleteMasterRecord,
  fetchMasterListById,
  searchMasterList,
} from "../../../../redux/feature/manufacturing_app/commonMasterListSlice";
import { toastFunc } from "../../../../components/common/util";
import { ConfirmationModal } from "../../../common/ConfirmationModal";
import { ErrorModal } from "../../../common/errorModal";
import ViewReason from "./ViewReason";
import { AlertModal } from "../../../common/AlertModal";
import { formatDateTime } from "../../../../common/Validations";

const JobStatus = () => {
  const [open, setOpen] = useState(false);
  const [openViewReason, setOpenViewReason] = useState(false);
  const [reasonData, setReasonData] = useState([]);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState("");
  const [selectedItem, setSelectedItem] = useState([]);
  const [editJobStatus, setEditJobStatus] = useState();
  const [confirmModel, setConfirmModel] = useState(false);
  const [jobstatusCode, setJobstatusCode] = useState([]);
  const [isAlert, setIsAlert] = useState(false);
  const [searchValue, setSearchValue] = useState();

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    dispatch(fetchMasterList(Constants.MASTER.JOBSTATUS)); // userSlice store
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleViewReasonClose = () => {
    setOpenViewReason(false);
  };

  const resetAlert = () => {
    setIsAlert(false);
  };
  const handleSave = (data, edit) => {
    const param = { ...data };
    if (!edit) {
      param.method = Constants.MASTER.JOBSTATUS.ADD;
    } else {
      param.method = Constants.MASTER.JOBSTATUS.UPDATE;
    }
    param.edit = edit;
    dispatch(addMasterRecord(param)).then((res) => {
      console.log(">> item >>", res);
      if (res?.payload?.status === 200) {
        if (!edit) {
          toastFunc(
            Constants.MASTER.TOAST.success,
            t("msg_master_list.msg_jobstatus.success_message"),
            2000
          );
        } else {
          toastFunc(
            Constants.MASTER.TOAST.success,
            t("msg_master_list.msg_jobstatus.update_success_message"),
            2000
          );
        }
        dispatch(fetchMasterList(Constants.MASTER.JOBSTATUS)); // userSlice store
        setOpen(false);
      } else if (res?.payload?.errorcode === 1010) {
        setError(t("msg_master_list.msg_jobstatus.duplicate_jobstatus"));
        setIsError(true);
      } else {
        setError(t("msg_master_list.msg_jobstatus.jobstatus_add_error"));
        setIsError(true);
      }
    });
  };

  const handleViewReason = (row) => {
    let param = {};
    param.url = "getReasonDataByJobId";
    param.page = Constants.MASTER.REASON.name;
    param.id = row.jobstatusCode;

    if (row.jobstatusCode) {
      dispatch(fetchMasterListById(param)).then((result) => {
        //console.log('Done!',openViewMachines);
        setOpenViewReason(true);
        setReasonData(result?.payload);
        setJobstatusCode(row.jobstatusCode);
      });
    }
  };

  const handleDelete = () => {
    let param = {};
    param.jobStatusList = selectedItem;
    param.method = Constants.MASTER.JOBSTATUS.DELETE;

    dispatch(deleteMasterRecord(param)).then((res) => {
      console.log(">> item >>", res);
      if (res?.payload?.status === 200) {
        toastFunc(
          Constants.MASTER.TOAST.success,
          t("msg_master_list.msg_jobstatus.delete_success_message"),
          2000
        );
        dispatch(fetchMasterList(Constants.MASTER.JOBSTATUS));
        setSelectedItem([]);
        setConfirmModel(false);
      } else {
        setIsError(true);
        toastFunc(
          Constants.MASTER.TOAST.error,
          t("msg_master_list.msg_jobstatus.invalid_input"),
          4000
        );
      }
    });
  };

  const handleOpen = (data) => {
    if (data) {
      setEditJobStatus(data);
    }
    setOpen(true);
  };

  const handleRowSelected = ({ selectedRows }) => {
    const selectJobStatus = selectedRows.map((item) => item.jobstatusCode);
    setSelectedItem([...selectJobStatus]);
  };

  const confirmBeforeDelete = (data, singleDelete = false) => {
    if (singleDelete) {
      setSelectedItem([data.jobstatusCode]);
      setConfirmModel(true);
    } else {
      if (selectedItem.length === 0) {
        setIsAlert(true);
        return;
      } else {
        setConfirmModel(true);
      }
    }
  };

  const resetError = () => {
    setIsError(false);
    setError("");
  };

  let masterList = useSelector((state) => state?.masterList?.page); // User Details from Store

  let rowsData = masterList[Constants.MASTER.JOBSTATUS.name]?.data;

  const handleSearch = () => {
    const param = {
      ...Constants.MASTER.JOBSTATUS,
      value: searchValue,
    };
    if (searchValue) {
      dispatch(searchMasterList(param)).then((res) => {
        if (res?.payload?.status === 200) {
          rowsData = res?.payload?.data;
        }
      });
    }
  };

  const onSearchChange = (e) => {
    if (e.target.value) {
      setSearchValue(e.target.value);
    } else {
      dispatch(fetchMasterList(Constants.MASTER.JOBSTATUS));
      setSearchValue(e.target.value);
    }
  };

  const columnsData = [
    {
      name: t("msg_common.actions"),
      cell: (row) => (
        <>
          <span>
            <i
              className="bi bi-pencil-square iconTable"
              onClick={() => handleOpen(row)}
            ></i>
          </span>
          <span>
            <i
              className="bi bi-trash3 iconTable"
              onClick={() => confirmBeforeDelete(row, true)}
            ></i>
          </span>
        </>
      ),
      width: "100px",
    },
    {
      name: t("msg_master_list.msg_jobstatus.code"),
      selector: (row) => row.jobstatusCode,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.jobstatusCode} </p>
        </div>
      ),
    },
    {
      name: t("msg_master_list.msg_jobstatus.jobstatus_name"),
      selector: (row) => row.jobstatusName,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.jobstatusName} </p>
        </div>
      ),
    },
    {
      name: t("msg_master_list.msg_jobstatus.view_reason"),
      cell: (row) => (
        <Button variant="outline-primary" onClick={() => handleViewReason(row)}>
          {row.reason}
          {"Reason"}
        </Button>
      ),
      center: true,
      width: "150px",
    },
    {
      name: t("msg_common.status"),
      cell: (row) => (
        <>
          {row.jobStatus === Constants.MASTER.STATUS.Active ? (
            <span className="bg-table-status bg-table-success-status">
              {t("msg_common.active")}
            </span>
          ) : row.jobStatus === Constants.MASTER.STATUS.Inactive ? (
            <span className="bg-table-status bg-table-danger-status">
              {t("msg_common.inactive")}
            </span>
          ) : (
            row.jobStatus
          )}
        </>
      ),
      center: true,
      width: "150px",
    },
    {
      name: t("msg_common.created_date"),
      selector: (row) => row.createdDate,
      sortable: true,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">
            {formatDateTime(row?.createdDate)}{" "}
          </p>
        </div>
      ),
      center: true,
      width: "200px",
    },
  ];

  return (
    <main className="dashboard main" id="main">
      <Row className="justify-center subContent">
        <Col xs={8} md={8} className="rightSide">
          <div className="rightSideInner timesheet">
            <h2 className="mainTitle">
              {t("msg_master_list.msg_jobstatus.name")}
            </h2>
            <p className="subText">
              {t("msg_master_list.msg_jobstatus.details")}
            </p>
          </div>
        </Col>
        <Col xs={4} md={4} className="rightSide">
          <Form>
            <Form.Group>
              <InputGroup>
                <Form.Control
                  type="search"
                  placeholder={t("msg_common.search_placeholder")}
                  onChange={(e) => onSearchChange(e)}
                />
                <InputGroup.Text>
                  <i className="bi bi-search" onClick={handleSearch}></i>
                </InputGroup.Text>
              </InputGroup>
            </Form.Group>
          </Form>
        </Col>
        <hr />
      </Row>
      <MasterList
        columnsData={columnsData}
        rowsData={rowsData}
        paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
        pagination
        selectableRows
        handleClose
        handleOpen={handleOpen}
        handleDelete={confirmBeforeDelete}
        handleRowSelected={handleRowSelected}
      />
      {open && (
        <JobStatusModal
          data={editJobStatus}
          show={open}
          onHide={handleClose}
          onSave={handleSave}
        ></JobStatusModal>
      )}
      {confirmModel && (
        <ConfirmationModal
          show={confirmModel}
          heading={t("msg_master_list.msg_jobstatus.delete_confirm_heading")}
          bodyMessage={t("msg_master_list.msg_jobstatus.delete_confirm_body")}
          onDelete={() => handleDelete()}
          onHide={() => setConfirmModel(false)}
          type={"delete"}
        ></ConfirmationModal>
      )}
      {isError && (
        <ErrorModal
          show={isError}
          heading={t("msg_master_list.msg_jobstatus.jobstatus_error_heading")}
          bodyMessage={error}
          onHide={() => {
            resetError();
          }}
        ></ErrorModal>
      )}

      <ViewReason
        rowsData={reasonData}
        show={openViewReason}
        onHide={handleViewReasonClose}
        jobstatusCode={jobstatusCode}
      ></ViewReason>

      {isAlert && (
        <AlertModal
          show={isAlert}
          heading={t("msg_common.alert")}
          bodyMessage={t("msg_common.selectRecord")}
          onHide={() => {
            resetAlert();
          }}
        ></AlertModal>
      )}
    </main>
  );
};

export default JobStatus;
